module.exports = __webpack_public_path__ + "static/media/Bollywood Kiss.49257bbb.png";